import VueRouter from 'vue-router';
import { Store } from 'vuex';
import RootState from '@/store/RootState';
import TMAlert from '../models/TMAlert';
import TMAuth from '../TMAuth';

export default class RequestException {
  public error: any;
  public httpCode: number = 500;
  public message: string = '';
  private store: Store<RootState>;
  private router: VueRouter;

  constructor(error: any, store: Store<RootState>, router: VueRouter) {
    this.error = error;
    this.httpCode = error.response.status;
    this.message = error.response.data.message;
    this.store = store;
    this.router = router;

    this.showError();
  }

  private showError(): void {
    switch (this.httpCode) {
      case 401:
        this.unauthorizedMessage();
        this.router.push('/login');
        break;

      case 422:
        this.unprocessableEntity();
        break;

      default:
        this.genericError();
    }
  }

  private dispatchAlert(title: string, message: string): void {
    this.store.dispatch(
      'setAlert',
      new TMAlert({
        title,
        message,
        state: true,
      }),
    );
  }

  private unauthorizedMessage(): void {
    TMAuth.logout(this.router);

    this.dispatchAlert('Não autorizado', 'Por favor faça login no sistema para utilizá-lo');
  }

  private unprocessableEntity(): void {
    const message =
      this.router.currentRoute.name === 'Login' ? 'Credeciais inválidas' : this.message;

    this.dispatchAlert('Dados inválidos', message);
  }

  private genericError(): void {
    this.dispatchAlert('Erro', 'Desculpe algo deu errado. Tente novamente.');
  }
}
